import { InputAdornment, TextField } from '@mui/material';
import { MagnifyingGlass } from '@phosphor-icons/react';
import React from 'react';

interface IntegrationSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  isDark: boolean;
  placeholder?: string;
}

const IntegrationSearchBar: React.FC<IntegrationSearchBarProps> = ({
  value,
  onChange,
  isDark,
  placeholder = 'Search integrations…',
}) => {
  return (
    <TextField
      size='small'
      fullWidth
      value={value}
      onChange={event => onChange(event.target.value)}
      placeholder={placeholder}
      InputProps={{
        startAdornment: (
          <InputAdornment position='start'>
            <MagnifyingGlass
              size={16}
              weight='bold'
              color={isDark ? '#98A2B3' : '#667085'}
            />
          </InputAdornment>
        ),
      }}
      sx={{
        maxWidth: 420,
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          backgroundColor: isDark ? '#101828' : '#FFFFFF',
          fontSize: '14px',
        },
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: isDark ? '#475467' : '#D0D5DD',
        },
      }}
    />
  );
};

export default IntegrationSearchBar;
